import React, { useState, useEffect } from "react";

import { Colors } from "../../config/default";
import { Typography, Grid, Checkbox, FormControlLabel } from "@mui/material";
import TextButton from "../button";
import generatePDF from "../../common";
import { FONT_SIZE_XXL } from "../../constants/appConstants";

function DownloadPDF({ allData, lumpSumpData, handleClose }) {
  const typographyOptions = [
    "Client Information",
    "Settlement Range",
    "Scores",
    "Creditors Contract Information",
    "Creditors Contract Details Summary",
    "Strategy 1 Recommendations",
    "Strategy 2 Recommendations",
    "Strategy 3 Recommendations",
  ];

  const [checkboxState, setCheckboxState] = useState({
    "Client Information": true,
    "Settlement Range": true,
    Scores: true,
    "Creditors Contract Information": true,
    "Creditors Contract Details Summary": true,
    "Strategy 1 Recommendations": true,
    "Strategy 2 Recommendations": true,
    "Strategy 3 Recommendations": true,
  });

  useEffect(() => {
    setCheckboxState((prevState) => ({
      ...prevState,
      "Client Information": true,
      "Settlement Range": true,
      Scores: true,
    }));
  }, []);
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const isDownloadDisabled = !Object.values(checkboxState).some(
    (isChecked) => isChecked
  );
  return (
    <Grid
      container
      spacing={2}
      sx={{
        paddingLeft: { xs: "0.5rem", sm: "2rem" },
        paddingRight: { xs: "0.5rem", sm: "2rem" },
      }}
    >
      <Typography
        sx={{
          fontFamily: "Nunito",
          fontSize: FONT_SIZE_XXL,
          fontWeight: "600",
          marginTop: "1rem",
        }}
      >
        Download Settlement Range data from the following :
      </Typography>
      {typographyOptions?.map((name) => (
        <Grid item xs={12} key={name}>
          <FormControlLabel
            control={
              <Checkbox
                name={name}
                checked={checkboxState[name]}
                onChange={handleCheckboxChange}
                sx={{
                  "&.Mui-checked": {
                    color: Colors.SKY_BLUE, // Checked color
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontFamily: "Nunito", fontWeight: "400" }}>
                {name}
              </Typography>
            }
          />
        </Grid>
      ))}
      <Grid
        container
        item
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <TextButton
          buttonText="CANCEL"
          height="2rem"
          marginRight="1rem"
          width="6rem"
          onClick={handleClose}
          backgroundColor={Colors.ORANGE_COLOR}
          hoverColor={Colors.ORANGE_COLOR}
        />
        <TextButton
          buttonText={"Download"}
          boxShadow="none"
          height={"2rem"}
          width="6rem"
          backgroundColor={Colors.SKY_BLUE}
          fontColor={Colors.WHITE}
          hoverColor={Colors.SKY_BLUE}
          border={`1px solid ${Colors.SKY_BLUE}`}
          borderRadius="5px"
          onClick={() => generatePDF(allData, lumpSumpData, checkboxState)}
          disabled={isDownloadDisabled}
        />
      </Grid>
    </Grid>
  );
}

export default DownloadPDF;
